module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5r9n3n-fd25961bfc6f379c61bc5ab0e5ebf9f0.svg";